import { useMutation } from "@apollo/client";
import React, { useState } from "react";
import { FaExclamationTriangle, FaSpinner } from "react-icons/fa";

import renderStatusModal from "../../../components/Forms/renderStatusModal";
import { DELETE_CASES, REASSIGN_CASES } from "./queries";
import { CaseTableActions } from "../../../global/css/component/Table";
import SimpleModal from "../../SimpleModal";
import "./CasesTable.scss";
import { filterOnSearchTerm } from "./../../SimpleForm/CaseReuse/helpers";
import { ReactTable } from "../../SimpleForm/ReactTable";

const pause = (delay) => {
  return new Promise((res) => setTimeout(res, delay));
};

export default (props) => {
  let {
    numberChecked,
    checkedCases,
    setCheckedCases,
    setSelectedAll,
    isInitiated,
    forceRefetch,
    isPresubmitted,
    groupRole,
    groupMembers,
    tab,
    formId,
    refetchTabsTable,
  } = props;
  // delete
  const [page2, setPage2] = useState(null);
  const toggleDeleteModal = function () {
    setPage2(0);
  };
  const closeDeleteModal = () => {
    setPage2(null);
  };

  const [deleteCasesMutation] = useMutation(DELETE_CASES, {
    onCompleted() {
      renderStatusModal(true, "Successfully deleted cases.");
      setFetchLoading(false);
      closeDeleteModal();
      forceRefetch();
      refetchTabsTable();
    },
    onError() {
      renderStatusModal(false, "Could not delete cases.");
      setFetchLoading(false);
      closeDeleteModal();
    },
  });
  const deleteCases = () => {
    setFetchLoading(true);
    let variables = { formId, applicationIds: checkedCases };
    deleteCasesMutation({ variables });
  };

  // reassign
  const [fetchLoading, setFetchLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [page, setPage] = useState(null);
  const toggleReassignModal = function () {
    setPage(0);
  };
  const closeReassignModal = () => {
    setPage(null);
    setSearchTerm("");
    setSelectedUser(null);
  };
  const [reassignCasesMutation] = useMutation(REASSIGN_CASES, {
    async onCompleted() {
      await pause(8000);
      renderStatusModal(true, "Successfully reassigned cases.");
      setFetchLoading(false);
      closeReassignModal();
      forceRefetch();
      setSelectedUser(null);
      setCheckedCases([]);
      setSelectedAll(false);
      refetchTabsTable();
    },
    onError() {
      renderStatusModal(false, "Could not reassign cases.");
      setFetchLoading(false);
      closeReassignModal();
      setSelectedUser(null);
      setCheckedCases([]);
      setSelectedAll(false);
    },
  });
  const reassignCasesToUser = () => {
    setFetchLoading(true);
    let variables = {
      applicationIds: checkedCases,
      newUser: { userId: selectedUser.userId },
      formId,
      tab,
    };
    reassignCasesMutation({ variables });
  };

  const renderSearch = () => (
    <div className="usa-search usa-search-big margin-top-2">
      <div role="search">
        <input
          type={"text"}
          className={"usa-input pwd-input"}
          placeholder={"Type assignee name here..."}
          id={"job-order-search"}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button
          type="button"
          className={"usa-button usa-button-primary btn-pwd-search"}
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          Search
        </button>
        <button
          type="button"
          className={"reset-button"}
          onClick={(e) => {
            setSearchTerm("");
            setSelectedUser(null);
          }}
        >
          Reset
        </button>
      </div>
    </div>
  );
  const getColumns = () => {
    let columns = [
      {
        Header: "Name",
        id: "groupMembers",
        accessor: "groupMembers",
        Cell: ({
          row: {
            original: { first_name, last_name },
          },
        }) => (
          <span>
            {first_name} {last_name}
          </span>
        ),
        width: "100%",
      },
    ];
    return columns;
  };

  let columns = [
    {
      id: "radio",
      accessor: "",
      Cell: ({ row: { original } }) => {
        const user = {
          userId: original.subjectId,
          name: `${original.first_name} ${original.last_name}`,
        };

        return (
          <>
            <input
              type="radio"
              name="pwd-selection"
              className="usa-radio-input"
              id={`pwd-${original.subjectId}`}
              onChange={(e) => e}
              checked={selectedUser?.userId === original.subjectId}
              onClick={() => setSelectedUser(user)}
            />
            <label
              className="usa-radio-label"
              htmlFor={`pwd-${original.subjectId}`}
              onChange={(e) => e}
              onClick={() => setSelectedUser(user)}
              checked={selectedUser?.userId === original.subjectId}
            />
          </>
        );
      },
      disableSortBy: true,
      fixedWidth: 25,
    },
  ];

  let addColumns = getColumns();
  addColumns.forEach((entry) => {
    columns.push(entry);
    return columns;
  });

  return (
    <>
      <SimpleModal
        toggleModal={toggleReassignModal}
        modalStatus={page === 0}
        renderButton={() => null}
        minWidth={"40%"}
        onRequestClose={() => closeReassignModal()}
      >
        <h3>Reassign Case</h3>
        <p className="pwd-description">
          Locate the network member to which the selected case(s) will be
          assigned
          <br />
        </p>
        <div>
          <div className="pwd-search-row">{renderSearch()}</div>
        </div>
        <ReactTable
          tableStyle={{ marginTop: 25 }}
          defaultSortBy={[
            {
              id: "groupMembers",
              desc: false,
            },
          ]}
          data={filterOnSearchTerm(groupMembers, searchTerm)}
          showPagination={true}
          columns={columns}
        />
        {page === 0 && (
          <button
            className={"usa-button usa-button-primary modal-submit"}
            disabled={!selectedUser}
            type="button"
            onClick={() => {
              setPage(1);
            }}
          >
            Continue
          </button>
        )}
      </SimpleModal>
      <SimpleModal
        toggleModal={toggleReassignModal}
        modalStatus={page === 1}
        renderButton={() => null}
        minWidth={"40%"}
        onRequestClose={() => closeReassignModal()}
      >
        <div className="reassign-disclaimer-body">
          <p className="modal-centered-icon reassign-disclaimer-icon">
            <FaExclamationTriangle color={"#e9e9e9"} size={"2em"} />
          </p>
          <h3>Reassign Case</h3>
          <p className="reassign-disclaimer-text">
            Do you want to continue reassigning selected cases to{" "}
            {selectedUser?.name}?
          </p>
        </div>

        <div>
          <button
            type="button"
            style={{ marginTop: "15px", float: "left" }}
            className={"usa-button usa-button--outline"}
            onClick={() => setPage(0)}
            disabled={fetchLoading}
          >
            Back
          </button>
          <button
            type={"button"}
            className={"usa-button usa-button-primary modal-submit"}
            onClick={reassignCasesToUser}
          >
            Acknowledge & Finish{" "}
            <FaSpinner
              style={{
                width: "10px",
                height: "10px",
                marginleft: "8px",
                transition: "width 400ms ease-in-out",
                "-webkit-transition": "width 400ms ease-in-out",
                "-moz-transition": "width 400ms ease-in-out",
              }}
              className={fetchLoading ? "icon-spin" : "hidden"}
            />
          </button>
        </div>
      </SimpleModal>

      <SimpleModal
        toggleModal={toggleDeleteModal}
        modalStatus={page2 === 0}
        renderButton={() => null}
        minWidth={"40%"}
        onRequestClose={() => closeDeleteModal()}
      >
        <div className="delete-modal-first-page">
          <p className="modal-centered-icon">
            <FaExclamationTriangle color={"#e9e9e9"} size={"4em"} />
          </p>

          <h3>
            Do you want to continue with the deletion of the selected initiated
            cases?
          </h3>
          <div className="deleteContinue">
            <button
              onClick={deleteCases}
              type="button"
              class="usa-button usa-button-alert-fill"
              coloring="alert-fill"
            >
              Yes, delete selected cases{" "}
              <FaSpinner
                style={{
                  width: "10px",
                  height: "10px",
                  marginleft: "8px",
                  transition: "width 400ms ease-in-out",
                  "-webkit-transition": "width 400ms ease-in-out",
                  "-moz-transition": "width 400ms ease-in-out",
                }}
                className={fetchLoading ? "icon-spin" : "hidden"}
              />
            </button>
          </div>
        </div>
      </SimpleModal>

      <CaseTableActions>
        <div className="casesSelected">
          <div className="top" style={{ margin: "auto" }}>
            <button className="badge">
              <div className="badge-number">{numberChecked}</div>
            </button>
            {numberChecked === 1 ? <span> Case</span> : <span> Cases</span>}{" "}
            <span>Selected</span>
          </div>
        </div>
        <div className="clearCasesBtn">
          <div>
            <button
              className="reassignButton"
              onClick={() => {
                setCheckedCases([]);
                setSelectedAll(false);
              }}
            >
              Clear
            </button>
          </div>
        </div>
        <div>
          <div className="reassign">
            {isPresubmitted != true && groupRole === "Master" && (
              <button className="reassignButton" onClick={toggleReassignModal}>
                Reassign
              </button>
            )}
          </div>
          <div className="delete">
            {isInitiated == true && (
              <button className="deleteButton" onClick={toggleDeleteModal}>
                Delete
              </button>
            )}
          </div>
        </div>
      </CaseTableActions>
    </>
  );
};
